import { render, staticRenderFns } from "./SectionKeyVisual.vue?vue&type=template&id=15028337&"
import script from "./SectionKeyVisual.vue?vue&type=script&lang=js&"
export * from "./SectionKeyVisual.vue?vue&type=script&lang=js&"
import style0 from "./SectionKeyVisual.vue?vue&type=style&index=0&id=15028337&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports